import MContentCard from './MContentCard.vue';

export { MContentCard };
export default MContentCard;
